import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './components/AppRouter';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { GameTimerProvider } from './contexts/GameTimerContext';
import { MeetingLockProvider } from './contexts/MeetingLockContext';
import InactivityTimeout from './components/InactivityTimeout';
import { Toaster } from './components/ui/sonner';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import PrivateBrowsingBanner from './components/PrivateBrowsingBanner';
import FeedbackWidget from './components/FeedbackWidget';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import { cleanupLegacyStorage } from './lib/safeStorage';
import { Theme4AGlobalDecor } from './components/Theme4A';
import './App.css';
import './styles/block-print.css';

function App() {
  // Tudor 11 Oct 2026: one-shot sweep of pre-9-Oct PostHog persistence rows
  // (ph_*). PostHog itself now initialises with persistence: "memory" (see
  // public/index.html) so nothing new is written, but existing visitors still
  // carry the old rows on disk. This clears them on every app load.
  useEffect(() => {
    try { cleanupLegacyStorage(); } catch (_) { /* storage unavailable */ }
  }, []);

  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <MeetingLockProvider>
            <GameTimerProvider>
              <InactivityTimeout />
              <PrivateBrowsingBanner />
              <AppRouter />
              <FeedbackWidget />
              <Footer />
              <CookieBanner />
              <PWAInstallPrompt />
              <Theme4AGlobalDecor />
              <Toaster position="top-center" />
            </GameTimerProvider>
          </MeetingLockProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;